import React from 'react';
import { Dropdown, Field, Option } from '@fluentui/react-components';

interface IAnticipatedTerminationQuarterDropdownProps {
  value?: string;
  onChange: (value: string) => void;
}

const Quarters = [
  { key: 'Q1', text: 'Q1' },
  { key: 'Q2', text: 'Q2' },
  { key: 'Q3', text: 'Q3' },
  { key: 'Q4', text: 'Q4' },
];

const AnticipatedTerminationQuarterDropdown = (
  props: IAnticipatedTerminationQuarterDropdownProps,
): JSX.Element => {
  const { value, onChange } = props;

  return (
    <Field label="Anticipated Termination Quarter">
      <Dropdown
        placeholder="Select One"
        value={value || ''}
        selectedOptions={value ? [value] : []}
        onOptionSelect={(_ev, data) => onChange(data.optionValue ?? '')}
      >
        {Quarters.map((quarter) => (
          <Option key={quarter.key} value={quarter.text}>
            {quarter.text}
          </Option>
        ))}
      </Dropdown>
    </Field>
  );
};

export default AnticipatedTerminationQuarterDropdown;
